import selectSiblings from '../helpers/siblings';
import { parseHTML } from '../helpers/general';

const selectFields = document.querySelectorAll('.select-field:not(.select-initiated)');

selectFields.forEach((selectField) => {
  selectField.append(parseHTML('<div class="form-field">'));

  const selectElement = selectField.querySelector('select');

  selectField?.querySelectorAll('.form-field').forEach((formField) => {
    const selectedText = selectElement?.querySelector('option:checked')?.innerText;
    formField.innerHTML = selectedText;
  });

  selectElement?.addEventListener('change', (e) => {
    const formFieldSiblings = selectSiblings(e.currentTarget, '.form-field');

    formFieldSiblings.forEach((formFieldSibling) => {
      const selected = selectField.querySelector('option:checked');

      formFieldSibling.innerHTML = selected.innerText;
    });

    if (e.target.querySelector('option:checked').getAttribute('value') != null) {
      formFieldSiblings.forEach((formFieldSibling) => {
        formFieldSibling.classList.add('selected');
      });
    } else {
      formFieldSiblings.forEach((formFieldSibling) => {
        formFieldSibling.classList.remove('selected');
      });
    }
  });
});
